module.exports = __webpack_public_path__ + "static/media/roo_wor_sti.2c273bce.png";